module.exports = {
	"id": "PR",
	"name": "Puerto Rico",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.042327,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.009406,
			"19": null,
			"20": 0.004703,
			"21": 0.004703,
			"22": 0.014109,
			"23": null,
			"24": null,
			"25": 0.032921,
			"26": null,
			"27": null,
			"28": 0.004703,
			"29": 0.009406,
			"30": null,
			"31": 0.014109,
			"32": 0.009406,
			"33": 0.023515,
			"34": 0.023515,
			"35": 0.023515,
			"36": 0.028218,
			"37": 0.009406,
			"38": 0.037624,
			"39": 0.04703,
			"40": 0.009406,
			"41": 0.014109,
			"42": 0.028218,
			"43": 0.070545,
			"44": 0.04703,
			"45": 0.018812,
			"46": 0.018812,
			"47": 0.032921,
			"48": 0.065842,
			"49": 1.12872,
			"50": 0.089357,
			"51": 0.343319,
			"52": 0.333913,
			"53": 16.197132,
			"54": 4.397305,
			"55": 0.037624,
			"56": 0.014109,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.009406,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.004703,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.014109,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.014109,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.004703,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.009406,
			"36": 0.004703,
			"37": 0.014109,
			"38": 0.023515,
			"39": 0.018812,
			"40": 0.014109,
			"41": 0.009406,
			"42": 0.014109,
			"43": 0.056436,
			"44": 0.018812,
			"45": 0.108169,
			"46": 0.056436,
			"47": 0.263368,
			"48": 0.324507,
			"49": 3.95052,
			"50": 0.04703,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.009406
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.004703,
			"28": null,
			"29": 0.032921,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.009406,
			"34": null,
			"35": null,
			"36": 0.018812,
			"37": 0.084654,
			"38": 0.032921,
			"39": null,
			"40": 0.249259,
			"41": 0.032921,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.009406
		},
		"safari": {
			"0": null,
			"4": 0.018812,
			"5": 0.042327,
			"6": 0.009406,
			"7": 0.023515,
			"8": 0.211635,
			"9": 0.258665,
			"10": 1.660159,
			"3.1": null,
			"3.2": null,
			"5.1": 0.122278,
			"6.1": 0.070545,
			"7.1": 0.014109,
			"9.1": 1.298028
		},
		"ios_saf": {
			"8": 0,
			"10": 10.3524770883,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.278987278414,
			"8.1-8.4": 0.515417175375,
			"9.0-9.2": 0.245887092839,
			"9.3": 3.75135436511
		},
		"android": {
			"3": 0,
			"4": 0.0571993875969,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00714992344961,
			"4.1": 0.206326362403,
			"4.2-4.3": 0.515815906008,
			"4.4": 1.18280162209,
			"4.4.3-4.4.4": 1.19301579845
		},
		"ie": {
			"6": null,
			"7": 0.0141751152765,
			"8": 0.203176652296,
			"9": 0.396903227741,
			"10": 0.2409769597,
			"11": 4.18638404499,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00767119776788,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000213088826885
		},
		"edge": {
			"12": 0.183417,
			"13": 0.954709,
			"14": 2.248034
		},
		"ie_mob": {
			"10": 0.11280371831,
			"11": 0.45927228169
		},
		"bb": {
			"7": 0.005297,
			"10": null
		},
		"samsung": {
			"0": 7.135059
		},
		"and_uc": {
			"0": 0.058267
		},
		"op_mini": {
			"0": 0.103352713405
		},
		"and_chr": {
			"0": 31.851123
		},
		"and_ff": {
			"0": 0.021188
		}
	},
	"total": 98.86861
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PR.json
 ** module id = 626
 ** module chunks = 0
 **/